import SingleBlog from "./SingleBlog";
import { useSelector } from "react-redux";
const Blog = () => {
    const blog = useSelector((state) => state.blog);
    const filters = useSelector( (state) => state.filters);
    return (
        <div
            className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none"
        >
            
            {blog
            .filter( (singleBlog) => {
                const {category} = filters;
                if(category.length > 0) {
                    return singleBlog.category === category;
                }
                return true;
            } )
            .filter( (singleBlog) => {
                const {author_name} = filters;
                if(author_name.length > 0) {
                    return singleBlog.author_name === author_name;
                }
                return true;
            } )
            .filter( (singleBlog) => {
                const {search} = filters;
                if(search.length > 0) {
                    let regex = new RegExp(search, 'i');
                    console.log(regex);
                    return singleBlog.title.search(regex) > -1 ;
                }
                return true;
            } )
            .map((singleBlog) => (<SingleBlog key={singleBlog.id} singleBlog={singleBlog} />))}


        </div>
    );
}

export default Blog;